import { createResourceRequest } from '../api';
import { Env } from '@/shared/config/environment';

const state = {
  selectedDocuments: [],
  persona: 'agent',
  utm: {},
  isSubmitting: false,
  submittedEmail: null,
};

const mutations = {
  SET_SELECTED_DOCUMENTS: (state, documents) => {
    state.selectedDocuments = documents;
  },
  TOGGLE_DOCUMENT: (state, slug) => {
    state.selectedDocuments = state.selectedDocuments.includes(slug)
      ? state.selectedDocuments.filter((item) => item !== slug)
      : [...state.selectedDocuments, slug];
  },
  SET_PERSONA: (state, persona) => {
    state.persona = persona;
  },
  SET_UTM: (state, utm) => {
    state.utm = utm;
  },
  SET_SUBMITTING: (state, isSubmitting) => {
    state.isSubmitting = isSubmitting;
  },
  SET_SUBMITTED_EMAIL: (state, email) => {
    state.submittedEmail = email;
  },
};

const actions = {
  startSelection({ commit }, documents) {
    commit('SET_SELECTED_DOCUMENTS', [...documents]);
    commit('SET_SUBMITTED_EMAIL', null);
  },
  toggleDocument({ commit }, slug) {
    commit('TOGGLE_DOCUMENT', slug);
  },
  setPersona({ commit }, persona) {
    commit('SET_PERSONA', persona);
  },
  rememberUtm({ commit }, utm) {
    if (Object.keys(utm).length > 0) {
      commit('SET_UTM', utm);
    }
  },
  async submitResourceRequest({ commit, state, dispatch }, { name, email, telephone, consent, cfToken, page }) {
    commit('SET_SUBMITTING', true);

    try {
      await createResourceRequest({
        name: name || null,
        email,
        telephone: telephone || null,
        persona: state.persona,
        documents: state.selectedDocuments,
        page,
        utm: Object.keys(state.utm).length > 0 ? state.utm : null,
        consent,
        cf_token: cfToken,
      });

      commit('SET_SUBMITTED_EMAIL', email);

      return { errors: null };
    } catch (error) {
      const responseData = error.response?.data;

      if (responseData?.status === 'validation' && responseData?.data) {
        return { errors: responseData.data };
      }

      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error,
          title: 'Не вдалося надіслати матеріали',
          message: responseData?.message || error.message || 'Спробуйте ще раз',
        }, { root: true });
      }

      return { errors: {} };
    } finally {
      commit('SET_SUBMITTING', false);
    }
  },
};

const getters = {
  selectedDocuments: (state) => state.selectedDocuments,
  isDocumentSelected: (state) => (slug) => state.selectedDocuments.includes(slug),
  persona: (state) => state.persona,
  isSubmitting: (state) => state.isSubmitting,
  submittedEmail: (state) => state.submittedEmail,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
